var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.753,
    height: 15.747,
    viewBox: "0 0 15.753 15.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Export",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72199",
    "data-name": "Path 72199",
    d: "M17.084,16.65a.665.665,0,0,0-.663.663v3.2a.938.938,0,0,1-.938.938H4.27a.938.938,0,0,1-.938-.938v-3.2a.666.666,0,0,0-1.332,0v3.2a2.271,2.271,0,0,0,2.27,2.27H15.483a2.271,2.271,0,0,0,2.27-2.27v-3.2A.675.675,0,0,0,17.084,16.65Z",
    transform: "translate(0 -5.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72200",
    "data-name": "Path 72200",
    d: "M16.026,6.2l-4-4a.665.665,0,0,0-.945,0l-4,4a.668.668,0,1,0,.945.945l3.53-3.536,3.536,3.536a.669.669,0,0,0,1.142-.472A.707.707,0,0,0,16.026,6.2Z",
    transform: "translate(-1.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72201",
    "data-name": "Path 72201",
    d: "M13.653,2a.666.666,0,0,0-.663.669v9.612a.663.663,0,1,0,1.325,0V2.669A.666.666,0,0,0,13.653,2Z",
    transform: "translate(-3.779)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.57471f9faf94599a0a6ddbab5daefba6.svg";
export { ForwardRef as ReactComponent };